import { render } from "./UserCriterionHistory.vue?vue&type=template&id=45c1cd6a"
import script from "./UserCriterionHistory.vue?vue&type=script&lang=js"
export * from "./UserCriterionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__